export enum CUSTOMERS_DASHBOARD_STORAGE_KEYS {
  IsLeaseCompanyPreference = "customers-is-lease-company-preference"
}
